import Link from "components/Link";
import Responsive from "components/Responsive";
import { COMPLAINTS_BOOK } from "configs/links";
import useLocalizedUrls from "hooks/useLocalizedUrls";
import { AcinSolution, Text } from "iparque-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { breakpoints } from "theme/breakpoints";
import { Container } from "./styles";

const TermsAndConditions: React.FC = () => {
  const { t } = useTranslation();
  const { privacyPolicyUrl, termsAndConditionsUrl, securityPolicyUrl } =
    useLocalizedUrls();

  return (
    <Container>
      <Responsive maxWidth={breakpoints.md}>
        <AcinSolution
          translation={t("10551") /* Uma solução */}
          className="mb-30"
        />
      </Responsive>
      <Text variant="body7" align="center" color="quaternary">
        {`© iParque ${new Date().getFullYear()} - ${
          t("6701") /* Todos os direitos reservados */
        }`}
      </Text>
      <div>
        <Text variant="body7" align="center" color="quaternary">
          <Link href={privacyPolicyUrl}>
            {t("6005") /* Política de Privacidade */}
          </Link>
          {" | "}
          <Link href={termsAndConditionsUrl}>
            {t("227") /* Termos e Condições */}
          </Link>
          {" | "}
          <Link href={securityPolicyUrl}>
            {t("9146") /* Política de Segurança das plataformas ACIN */}
          </Link>
          {" | "}
          <Link href={COMPLAINTS_BOOK}>
            {t("7209") /* Elogios, Sugestões e Reclamações */}
          </Link>
        </Text>
      </div>
    </Container>
  );
};

export default TermsAndConditions;
